import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export const Hero = () => {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden" data-id="element-85">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-86" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-87">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-88">
          <div className="flex-1 text-center lg:text-left" data-id="element-89">
            <FadeIn data-id="element-90">
              <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-6" data-id="element-91">
                ¿Tienes <span className="text-neon" data-id="element-92">habilidades básicas</span> y
                necesitas dinero esta semana?
              </h1>
            </FadeIn>

            <FadeIn delay={0.15} data-id="element-93">
              <h2 className="text-lg md:text-xl text-gray-300 font-sans font-medium mb-4 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-94">
                Esta guía te muestra exactamente cuál de los{' '}
                <span className="text-[#ADFF2F] font-semibold" data-id="element-95">
                  6 servicios más demandados en LATAM
                </span>{' '}
                puedes ofrecer hoy mismo — con mensajes listos para copiar y
                pegar y un plan hora por hora para los próximos 2 días.
              </h2>
            </FadeIn>

            <FadeIn delay={0.25} data-id="element-96">
              <p className="text-base md:text-lg text-gray-400 font-sans mb-6 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-97">
                Sin currículum. Sin entrevistas. Sin esperar semanas.
              </p>
            </FadeIn>

            <FadeIn delay={0.35} data-id="element-98">
              <div className="bg-[#111111] border border-[#ADFF2F]/20 rounded-xl p-4 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-99">
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-sans m-0" data-id="element-100">
                  📋{' '}
                  <span className="text-white font-semibold" data-id="element-101">
                    Recibes un PDF de 20 páginas con descarga inmediata.
                  </span>{' '}
                  Lo lees hoy. Lo aplicas esta semana.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.45} data-id="element-102">
              <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-103">
                <Button className="w-full sm:w-auto" showIcon={false} onClick={() => {
                document.getElementById('cta-final')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }} data-id="element-104">
                  ⚡ QUIERO EL PLAN DE 48 HORAS — 6.39 dólares
                </Button>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-3 gap-y-2 text-sm text-gray-400 mt-2" data-id="element-105">
                  <span data-id="element-106">✓ Acceso instantáneo</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-107" />
                  <span data-id="element-108">✓ Pago seguro</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-109" />
                  <span data-id="element-110">✓ Descarga inmediata en PDF</span>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-111">
            <FadeIn direction="left" delay={0.3} data-id="element-112">
              <motion.div animate={{
              y: [-10, 10, -10]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-113">
                <div className="absolute inset-0 bg-neon/20 blur-[60px] rounded-full" data-id="element-114" />
                <img src="https://cdn.magicpatterns.com/uploads/i98tbdWAFmDMydmCtG4nes/efectivo_inmediato_48_horas.png" alt="Plan de 48 Horas — Ebook PDF" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-115" />
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};